<template>
  <div>
    <v-divider></v-divider>
    <v-toolbar flat color="white">
      <v-flex xs4 sm4 md4 lg4 pa-4>
        <v-card flat color="white">
          <h3>Sales:</h3>
          <h3 class="green--text">{{salesvalue|currency}}</h3>
        </v-card>
      </v-flex>
      <v-flex xs4 sm4 md4 lg4 pa-4>
        <v-card flat color="white">
          <h3>Cost of Sales:</h3>
          <h3 class="red--text">{{cosvalue|currency}}</h3>
        </v-card>
      </v-flex>
      <v-flex xs4 sm4 md4 lg4 pa-4>
        <v-card flat color="white">
          <h3>Expenses:</h3>
          <h3 class="red--text">{{expensevalue|currency}}</h3>
        </v-card>
      </v-flex>
      <v-flex xs4 sm4 md4 lg4 pa-4>
        <v-card flat color="white">
          <h3>Loans:</h3>
          <h3 class="dark-grey--text">{{loanvalue|currency}}</h3>
        </v-card>
      </v-flex>
    </v-toolbar>
    <v-divider></v-divider>
    <v-toolbar flat color="white">
      <v-menu>
        <v-text-field
          :value="this.setStart"
          slot="activator"
          label="From Date"
          prepend-icon="date_range"
        ></v-text-field>
        <v-date-picker v-model="setStart"></v-date-picker>
      </v-menu>
      <v-menu>
        <v-text-field
          :value="this.setEnd"
          slot="activator"
          label="To Date"
          prepend-icon="date_range"
        ></v-text-field>
        <v-date-picker v-model="setEnd"></v-date-picker>
      </v-menu>
      <v-spacer></v-spacer>
      <v-btn round color="red white--text" @click="setStart=null;setEnd=null">CLEAR DATES</v-btn>
    </v-toolbar>
    <v-toolbar flat color="white">
      <v-autocomplete
                 clearable
                  hide-no-data
                  flat
                  color="primary"
        label="Description"
        :items="descriptionList"
        v-model="filterDescription"
       >
               </v-autocomplete>
       <v-autocomplete
                 clearable
                  hide-no-data
                  flat
                  color="primary"
        label="Transaction Type"
        :items="transactionTypes"
        v-model="filterTransactionType"
       >
               </v-autocomplete>
     <v-autocomplete
                 clearable
                  hide-no-data
                  flat
                  color="primary"
        label="Recurring / Once-Off"
        :items="frequencyList"
        v-model="filterFrequency"
      >
               </v-autocomplete>
      <v-btn round color="primary" @click="filterTransactions=true">Apply Filter</v-btn>
    </v-toolbar>
    <v-divider></v-divider>

    <v-toolbar flat color="white">
      <v-btn round color="primary"><v-icon>get_app</v-icon><download-excel
    :data="transactions"
    :fields="exportFields"
    worksheet="export"
    :name="'transaction_'+new Date().getTime()+'.xls'">
    Export to Excel
</download-excel></v-btn>
      <v-btn round color="primary" @click="addItem()">Add Transaction</v-btn>
      
    </v-toolbar>
    <v-divider></v-divider>
    <v-data-table
      disable-initial-sort
      :headers="fnoHeaders"
      :items="filteredTransactions"
      item-key="name"
      :rows-per-page-items="[10, 25, 50, 100]"
    >
      <template v-slot:items="props">
        <td class="justify-center layout px-0">
          <v-icon small @click="edit(props.item)">edit</v-icon>
          <v-icon small @click="deleteItem(props.item)">delete</v-icon>
        </td>
        <td class="text-xs-center">{{formatDate(props.item.date)}}</td>
        <td class="text-xs-center">{{props.item.description}}</td>
        <td class="text-xs-center">{{props.item.xeroCode}}</td>
        <td class="text-xs-center" >{{props.item.transactionType}}</td>
        <td class="text-xs-center" v-if="props.item.customerOrganisationId!==null">{{props.item.customerOrganisation.name}}</td>
        <td class="text-xs-center" v-else-if="props.item.supplierOrganisationId!==null">{{props.item.supplierOrganisation.name}}</td>
        <td class="text-xs-center" v-else></td>
        <td class="text-xs-center" v-if="props.item.isRecurring===true">Recurring</td>
        <td class="text-xs-center" v-else>Once-Off</td>
        <td
          class="text-xs-center red--text"
          v-if="props.item.transactionType!=='Sales'&&props.item.transactionType!=='Loan'"
        >{{props.item.amount | currency}}</td>
        <td
          class="text-xs-center green--text"
          v-else-if="props.item.transactionType==='Sales'||props.item.transactionType==='Loan'"
        >{{props.item.amount | currency}}</td>
      </template>
    </v-data-table>

    <v-dialog persistent v-model="addTransactionModal" max-width="950px">
      <v-card flat color="white">
        <v-toolbar flat class="primary">
          <h1 class="headline white--text">ADD TRANSACTION</h1>
        </v-toolbar>
        <v-card-text>
          <v-container grid-list-xs>
            <v-layout wrap>
              <v-flex xs12 sm6 md6>
                <v-menu>
                  <v-text-field
                    :value="this.editedItem.date"
                    slot="activator"
                    label="*Transaction Date"
                    prepend-icon="date_range"
                    required
                  ></v-text-field>
                  <v-date-picker v-model="editedItem.date"></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex xs12 sm6 md6>
               <v-autocomplete
                 clearable
                  hide-no-data
                  flat
                  color="primary"
                  label="*Transaction Type"
                  :items="transactionTypes"
                  v-model="editedItem.transactionType"
               >
               </v-autocomplete>
              </v-flex>
              <v-flex xs12 sm6 md6 v-if="editedItem.transactionType==='Loan'">
               <v-autocomplete
                 clearable
                  hide-no-data
                  flat
                  color="primary"
                  label="*Select Contributor"
                  :items="partners"
                  item-text="name"
                  item-value="id"
                  v-model="editedItem.loanAccountCustomerId"
                >
               </v-autocomplete>
              </v-flex>
              <v-flex xs12 sm6 md6 v-if="editedItem.transactionType==='Sales'">
               <v-autocomplete
                 clearable
                  hide-no-data
                  flat
                  color="primary"
                  label="*Transaction Category"
                  :items="salesTransactionCategories"
                  v-model="editedItem.description"
                >
               </v-autocomplete>
              </v-flex>
              <v-flex xs12 sm6 md6 v-if="editedItem.transactionType==='Cost of Sales'">
                <v-autocomplete
                 clearable
                  hide-no-data
                  flat
                  color="primary"
                  label="*Transaction Category"
                  :items="cosTransactionCategories"
                  v-model="editedItem.description"
                >
               </v-autocomplete>
              </v-flex>
              <v-flex xs12 sm6 md6 v-if="editedItem.transactionType==='Expense'">
                <v-autocomplete
                 clearable
                  hide-no-data
                  flat
                  color="primary"
                  label="*Transaction Category"
                  :items="expenseTransactionCategories"
                  v-model="editedItem.description"
                >
               </v-autocomplete>
              </v-flex>
              <v-flex xs12 sm6 md6 v-if="editedItem.transactionType==='Loan'">
               <v-autocomplete
                 clearable
                  hide-no-data
                  flat
                  color="primary"
                  label="*Transaction Category"
                  :items="loanTransactionCategories"
                  v-model="editedItem.description"
                >
               </v-autocomplete>
              </v-flex>
              <v-flex xs12 sm6 md6>
                <v-text-field v-model="editedItem.xeroCode" label="Xero Code"></v-text-field>
              </v-flex>

              <v-flex xs12 sm6 md6>
                <v-text-field v-model="editedItem.amount" label="*Amount"></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md6>
                <v-switch label="Is Recurring?" v-model="editedItem.isRecurring"></v-switch>
              </v-flex>
              <!-- <v-flex xs12 sm6 md6>
                <v-select
                  class="text-xs-center"
                  label="Network"
                  :items="locationnetworks"
                  item-text="name"
                  item-value="id"
                  v-model="editedItem.locationNetworkId"
                ></v-select>
              </v-flex>-->
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions class="justify-center layout px-0">
          <v-btn color="primary" round @click="addTransactionModal=false">Cancel</v-btn>
          <v-btn color="primary" round @click="saveNew">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog persistent v-model="editTransactionModal" max-width="950px">
      <v-card flat color="white">
        <v-toolbar flat class="primary">
          <h1 class="headline white--text">EDIT TRANSACTION</h1>
        </v-toolbar>
        <v-card-text>
          <v-container grid-list-xs>
            <v-layout wrap>
              <v-flex xs12 sm6 md6>
                <v-menu>
                  <v-text-field
                    :value="this.editedItem.date"
                    slot="activator"
                    label="*Transaction Date"
                    prepend-icon="date_range"
                    required
                  ></v-text-field>
                  <v-date-picker v-model="editedItem.date"></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex xs12 sm6 md6>
                <v-autocomplete
                 clearable
                  hide-no-data
                  flat
                  color="primary"
                  label="*Transaction Type"
                  :items="transactionTypes"
                  v-model="editedItem.transactionType"
                >
               </v-autocomplete>
              </v-flex>
              <v-flex xs12 sm6 md6 v-if="editedItem.transactionType==='Loan'">
               <v-autocomplete
                 clearable
                  hide-no-data
                  flat
                  color="primary"
                  label="*Select Contributor"
                  :items="partners"
                  item-text="name"
                  item-value="id"
                  v-model="editedItem.loanAccountCustomerId"
                >
               </v-autocomplete>
              </v-flex>
              <v-flex xs12 sm6 md6 v-if="editedItem.transactionType==='Sales'">
                <v-autocomplete
                 clearable
                  hide-no-data
                  flat
                  color="primary"
                  label="*Transaction Category"
                  :items="salesTransactionCategories"
                  v-model="editedItem.description"
                >
               </v-autocomplete>
              </v-flex>
              <v-flex xs12 sm6 md6 v-if="editedItem.transactionType==='Cost of Sales'">
                <v-autocomplete
                 clearable
                  hide-no-data
                  flat
                  color="primary"
                  label="*Transaction Category"
                  :items="cosTransactionCategories"
                  v-model="editedItem.description"
                >
               </v-autocomplete>
              </v-flex>
              <v-flex xs12 sm6 md6 v-if="editedItem.transactionType==='Expense'">
               <v-autocomplete
                 clearable
                  hide-no-data
                  flat
                  color="primary"
                  label="*Transaction Category"
                  :items="expenseTransactionCategories"
                  v-model="editedItem.description"
                >
               </v-autocomplete>
              </v-flex>
              <v-flex xs12 sm6 md6 v-if="editedItem.transactionType==='Loan'">
                <v-autocomplete
                 clearable
                  hide-no-data
                  flat
                  color="primary"
                  label="*Transaction Category"
                  :items="loanTransactionCategories"
                  v-model="editedItem.description"
               >
               </v-autocomplete>
              </v-flex>
              <v-flex xs12 sm6 md6>
                <v-text-field v-model="editedItem.xeroCode" label="Xero Code"></v-text-field>
              </v-flex>

              <v-flex xs12 sm6 md6>
                <v-text-field v-model="editedItem.amount" label="*Amount"></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md6>
                <v-switch label="Is Recurring?" v-model="editedItem.isRecurring"></v-switch>
              </v-flex>
              <!-- <v-flex xs12 sm6 md6>
                <v-select
                  class="text-xs-center"
                  label="Network"
                  :items="locationnetworks"
                  item-text="name"
                  item-value="id"
                  v-model="editedItem.locationNetworkId"
                ></v-select>
              </v-flex>-->
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions class="justify-center layout px-0">
          <v-btn color="primary" round @click="editTransactionModal=false">Cancel</v-btn>
          <v-btn color="primary" round @click="save">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import Api from "@/services/Api";
import dateformat from "dateformat";

export default {
  props: [
    "transactions",
    "locationnetworks",
    "locationnodeid",
    "partners",
    "descriptionlist",
    "salesvalue",
    "cosvalue",
    "expensevalue",
    "loanvalue",
    "locationnetworkid",
    "locationid",
    "isloading",
    "switchingcentreid"
  ],
  data() {
    return {
      addTransactionModal: false,
      editTransactionModal: false,
      setStart: null,
      setEnd: null,
      filteredTransactions: [],
      filterTransactions: false,
      filterDescription: null,
      filterTransactionType: null,
      totals: [],
      transactionSearch: false,
      filterFrequency: null,
      frequencyList: ["Recurring", "Once-Off"],
      descriptionList: this.descriptionlist,
      // frequencyList=['Recurring','Once-Off'],
      salesValue: null,
      cosValue: null,
      expenseValue: null,
      loanValue: null,
      exportFields: {
        'transactionDate': 'date',
        'description': 'description',
        'xeroCode': 'xeroCode',
        'transactionType': 'transactionType',
        'isRecurring': 'isRecurring',
        'location': 'location.locationDescription',
        'locationNetwork': 'locationNetwork.name',
        'locationNode': 'locationNode.name',
        'loanAccountCustomer': 'loanAccountCustomer.name',
        'customer': 'customer.name',
        'supplier': 'supplier.name',
        'amount': 'amount'
        },
      transactionTypes: ["Sales", "Cost of Sales", "Expense", "Loan"],
      salesTransactionCategories: [
        "Router Installation",
        "Data Activation Fee",
        "Internet Package"
      ],
      cosTransactionCategories: ["Labour", "Network Management Fee", "Layer 2"],
      expenseTransactionCategories: ["Hardware", "Labour", "Other"],
      loanTransactionCategories: [
        "Active Equipment",
        "Passive Equipment",
        "Civils",
        "Other"
      ],
      fnoHeaders: [
        {
          text: "Action",
          align: "center"
        },
        {
          text: "Transaction Date",
          align: "center",
          value: "date"
        },
        // {
        //   text: "Location",
        //   align: "center",
        //   value: "location.name"
        // },
        {
          text: "Description",
          align: "center",
          value: "description"
        },
        {
          text: "Xero Code",
          align: "center",
          value: "xeroCode"
        },
        {
          text: "Transaction Type",
          align: "center",
          value: "transactionType"
        },
        {
          text: "Customer/Supplier",
          align: "center",
          value: "customer.name"
        },
        {
          text: "Frequency",
          align: "center",
          value: "isRecurring"
        },
        {
          text: "Amount",
          align: "center",
          value: "amount"
        }
      ],
      Headers: [
        // {
        //   text: "Action",
        //   align: "center"
        // },
        {
          text: "Transaction Date",
          align: "center",
          value: "date"
        },
        // {
        //   text: "Location",
        //   align: "center",
        //   value: "location.name"
        // },
        {
          text: "Description",
          align: "center",
          value: "description"
        },
        {
          text: "Xero Code",
          align: "center",
          value: "xeroCode"
        },
        {
          text: "Transaction Type",
          align: "center",
          value: "transactionType"
        },
        {
          text: "Customer/Supplier",
          align: "center",
          value: "customer.name"
        },
        {
          text: "Frequency",
          align: "center",
          value: "isRecurring"
        },
        {
          text: "Debit",
          align: "center",
          value: "amount"
        },
        {
          text: "Credit",
          align: "center",
          value: "amount"
        }
      ],
      editedItem: {
        id: "",
        description: "",
        xeroCode: null,
        amount: null,
        isRecurring: false,
        transactionType: "",
        locationId: this.locationid,
        locationNetworkId: this.locationnetworkid,
        locationNodeId: this.locationnodeid,
        switchingCentreId: this.switchingcentreid,
        loanAccountCustomerId: null,
        date: "",
        isActive: true,
        isDeleted: false
      },
      defaultItem: {
        id: "",
        description: "",
        xeroCode: null,
        transactionType: "",
        amount: null,
        isRecurring: false,
        locationId: null,
        locationNetworkId: null,
        locationNodeId: null,
        loanAccountCustomerId: null,
        date: "",
        isActive: true,
        isDeleted: false
      }
    };
  },
  watch: {
    async filterTransactions(value) {
      // const route = {
      //   name: this.$route.name
      // };
      // if (value !== "") {
      //   route.query = {
      //     from: this.setStart,
      //     to: this.setEnd,
      //     transactionSearch: !this.transactionSearch,
      //     description: this.filterDescription,
      //     transactionType: this.filterTransactionType,
      //     frequency: this.filterFrequency
      //   };
      // }
      this.filteredTransactions=this.transactions
      if(this.setStart){
        let startDate = this.setStart
        this.filteredTransactions= await this.filteredTransactions.filter(function(el){
          return el.date>=startDate
      })
      }
      if(this.setEnd){
        let endDate = this.setEnd
        this.filteredTransactions= await this.filteredTransactions.filter(function(el){
          return el.date<=endDate
      })
      }
      if(this.filterDescription){
        let description = this.filterDescription
        this.filteredTransactions= await this.filteredTransactions.filter(function(el){
          return el.description===description
      })}
      if(this.filterTransactionType){
        let transactionType = this.filterTransactionType
        this.filteredTransactions= await this.filteredTransactions.filter(function(el){
          return el.transactionType===transactionType
      })
      }
      if(this.filterFrequency){
        let frequency = null
        if(this.filterFrequency==='Recurring'){
          frequency = true
        } else if(this.filterFrequency==='Once-Off'){
          frequency = false
        }
        if(frequency !==null){
          this.filteredTransactions= await this.filteredTransactions.filter(function(el){
          return el.isRecurring===frequency
      })
        }
      }


      // this.$router.push(route);
      this.filterTransactions = false;
    }
  },
  created() {
    this.filteredTransactions=this.transactions
  },
  methods: {
    edit(item) {
      if(this.authUpdate(this.$store.state.currentRoute)){
      this.editedItem = Object.assign({}, item);
      this.editedItem.date=new Date(this.editedItem.date).toISOString().substr(0, 10);
      this.editTransactionModal = true;
      }
    },
    deleteItem(item) {
      if(this.authDelete(this.$store.state.currentRoute)){
      this.editedItem = Object.assign({}, this.defaultItem);
      confirm("Are you sure you want to delete this transaction?") &&
        Api()
          .put("/transactions/" + item.id, {
            isActive: false,
            isDeleted: true
          })
          .then(this.$emit("transactionAdded"));
      }
    },
    getSum(total, num) {
      return total + num;
    },
    addItem(){
      if(this.authUpdate(this.$store.state.currentRoute)){
        this.addTransactionModal=true
      }
    },
    saveNew() {
      Api()
        .post("/transactions", {
          date: this.editedItem.date,
          description: this.editedItem.description,
          xeroCode: this.editedItem.xeroCode,
          amount: this.editedItem.amount,
          isRecurring: this.editedItem.isRecurring,
          transactionType: this.editedItem.transactionType,
          locationId: this.editedItem.locationId,
          locationNetworkId: this.editedItem.locationNetworkId,
          locationNodeId: this.editedItem.locationNodeId,
          switchingCentreId: this.editedItem.switchingCentreId,
          loanAccountCustomerId: this.editedItem.loanAccountCustomerId,
          isActive: this.editedItem.isActive,
          isDeleted: this.editedItem.isDeleted
        })
        .then(response => {
          this.allLocations = [];
          this.addTransactionModal = false;
          this.$emit("transactionAdded");
          if (
            this.editedItem.locationId === null &&
            this.editedItem.locationNetworkId !== null
          ) {
            Api()
              .get("/locationNetworks/" + this.editedItem.locationNetworkId)
              .then(result => {
                let amount =
                  this.editedItem.amount / result.data[0].locations.length;
                for (let i = 0; i < result.data[0].locations.length; i++) {
                  Api().post("/transactions", {
                    date: this.editedItem.date,
                    description: "Network: " + this.editedItem.description,
                    xeroCode: this.editedItem.xeroCode,
                    amount: amount,
                    isRecurring: this.editedItem.isRecurring,
                    transactionType: this.editedItem.transactionType,
                    locationId: result.data[0].locations[i].id,
                    locationNetworkId: this.editedItem.locationNetworkId,
                    locationNodeId: this.editedItem.locationNodeId,
                    loanAccountCustomerId: this.editedItem
                      .loanAccountCustomerId,
                    upstreamTransactionId: response.data.id,
                    isActive: this.editedItem.isActive,
                    isDeleted: this.editedItem.isDeleted
                  });
                }
              });
          }
          if (
            this.editedItem.locationNetworkId === null &&
            this.editedItem.locationNodeId !== null
          ) {
            Api()
              .get("/locationNodes/" + this.editedItem.locationNodeId)
              .then(result => {
                for (
                  let i = 0;
                  i < result.data[0].locationNetworks.length;
                  i++
                ) {
                  this.allLocations.push(
                    result.data[0].locationNetworks[i].locations.length
                  );
                }
                for (
                  let i = 0;
                  i < result.data[0].locationNetworks.length;
                  i++
                ) {
                  let amount =
                    (this.editedItem.amount / this.allLocations.reduce((a, b) => a + b, 0))*result.data[0].locationNetworks[i].locations.length;
                  Api()
                    .post("/transactions", {
                      date: this.editedItem.date,
                      description: "Node: " + this.editedItem.description,
                      xeroCode: this.editedItem.xeroCode,
                      amount: amount,
                      isRecurring: this.editedItem.isRecurring,
                      transactionType: this.editedItem.transactionType,
                      locationId: null,
                      locationNetworkId: result.data[0].locationNetworks[i].id,
                      locationNodeId: this.editedItem.locationNodeId,
                      switchingCentreId: this.editedItem.switchingCentreId,
                      loanAccountCustomerId: this.editedItem
                        .loanAccountCustomerId,
                      upstreamTransactionId: response.data.id,
                      isActive: this.editedItem.isActive,
                      isDeleted: this.editedItem.isDeleted
                    })
                    .then(nodeResult => {
                      
                      Api()
                        .get(
                          "/locationNetworks/" +
                            result.data[0].locationNetworks[i].id
                        )
                        .then(networkResult => {
                          let amountLocation =
                            amount / networkResult.data[0].locations.length;
                          for (
                            let x = 0;
                            x < networkResult.data[0].locations.length;
                            x++
                          ) {
                            Api().post("/transactions", {
                              date: this.editedItem.date,
                              description:
                                "Node: " + this.editedItem.description,
                              xeroCode: this.editedItem.xeroCode,
                              amount: amountLocation,
                              isRecurring: this.editedItem.isRecurring,
                              transactionType: this.editedItem.transactionType,
                              locationId: networkResult.data[0].locations[x].id,
                              locationNetworkId: result.data[0].locationNetworks[i].id,
                              locationNodeId: this.editedItem.locationNodeId,
                              switchingCentreId: this.editedItem.switchingCentreId,
                              loanAccountCustomerId: this.editedItem
                                .loanAccountCustomerId,
                              upstreamTransactionId: response.data.id,
                              isActive: this.editedItem.isActive,
                              isDeleted: this.editedItem.isDeleted
                            });
                          }
                        });
                    });
                }
              });
          }
        });
    },
    save(item) {
      if (
        this.editedItem.locationId === null &&
        this.editedItem.locationNetworkId !== null
      ) {
        Api()
          .put("/transactions/" + this.editedItem.id, {
            date: this.editedItem.date,
            description: this.editedItem.description,
            xeroCode: this.editedItem.xeroCode,
            amount: this.editedItem.amount,
            isRecurring: this.editedItem.isRecurring,
            transactionType: this.editedItem.transactionType,
            locationId: this.editedItem.locationId,
            locationNetworkId: this.editedItem.locationNetworkId,
            locationNodeId: this.editedItem.locationNodeId,
            loanAccountCustomerId: this.editedItem.loanAccountCustomerId,
            isActive: this.editedItem.isActive,
            isDeleted: this.editedItem.isDeleted
          })
          .then(response => {
            this.editTransactionModal = false;
            this.$emit("transactionAdded");
            Api()
              .get("/transactions/byUpstreamId/" + this.editedItem.id)
              .then(result => {
                let amount = this.editedItem.amount / result.data.length;
                for (let i = 0; i < result.data.length; i++) {
                  Api().put("/transactions/" + result.data[i].id, {
                    date: this.editedItem.date,
                    description: this.editedItem.description,
                    xeroCode: this.editedItem.xeroCode,
                    amount: amount,
                    isRecurring: this.editedItem.isRecurring,
                    transactionType: this.editedItem.transactionType,
                    locationId: result.data[i].id,
                    locationNetworkId: this.editedItem.locationNetworkId,
                    locationNodeId: this.editedItem.locationNodeId,
                    loanAccountCustomerId: this.editedItem
                      .loanAccountCustomerId,
                    upstreamTransactionId: this.editedItem.id,
                    isActive: this.editedItem.isActive,
                    isDeleted: this.editedItem.isDeleted
                  });
                }
              });
          });
      }
      if (
        this.editedItem.locationNetworkId === null &&
        this.editedItem.locationNodeId !== null
      ) {
        Api()
          .put("/transactions/" + this.editedItem.id, {
            date: this.editedItem.date,
            description: this.editedItem.description,
            xeroCode: this.editedItem.xeroCode,
            amount: this.editedItem.amount,
            isRecurring: this.editedItem.isRecurring,
            transactionType: this.editedItem.transactionType,
            locationId: this.editedItem.locationId,
            locationNetworkId: this.editedItem.locationNetworkId,
            locationNodeId: this.editedItem.locationNodeId,
            loanAccountCustomerId: this.editedItem.loanAccountCustomerId,
            isActive: this.editedItem.isActive,
            isDeleted: this.editedItem.isDeleted
          })
          .then(response => {
            this.editTransactionModal = false;
            this.$emit("transactionAdded");
            Api()
              .get("/transactions/byUpstreamId/" + this.editedItem.id)
              .then(result => {
                let amount = this.editedItem.amount / result.data.length;
                for (let i = 0; i < result.data.length; i++) {
                  Api().put("/transactions/" + result.data[i].id, {
                    date: this.editedItem.date,
                    description: this.editedItem.description,
                    xeroCode: this.editedItem.xeroCode,
                    amount: amount,
                    isRecurring: this.editedItem.isRecurring,
                    transactionType: this.editedItem.transactionType,
                    locationId: result.data[i].locationId,
                    locationNetworkId: result.data[i].locationNetworkId,
                    locationNodeId: this.editedItem.locationNodeId,
                    loanAccountCustomerId: this.editedItem
                      .loanAccountCustomerId,
                    upstreamTransactionId: this.editedItem.id,
                    isActive: this.editedItem.isActive,
                    isDeleted: this.editedItem.isDeleted
                  });
                }
              });
          });
      }
    },
    formatDate(date) {
      if (date !== null) {
        return dateformat(date, "dd/mm/yyyy");
      } else {
        null;
      }
    }
  }
};
</script>

